import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
var DeviceWarrantyInfoView = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceWarrantyInfoView, _super);
    function DeviceWarrantyInfoView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.warrantyInfo = null;
        _this.warningMessage = null;
        _this.loading = false;
        return _this;
    }
    Object.defineProperty(DeviceWarrantyInfoView.prototype, "isWarrantyValid", {
        get: function () {
            return this.warrantyInfo && this.warrantyInfo.validUntil && this.warrantyInfo.validUntil > new Date();
        },
        enumerable: true,
        configurable: true
    });
    DeviceWarrantyInfoView.prototype.mounted = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var warrantyValues, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.get("devicesensorlog/warranty", { params: { serialNumber: this.device.serial } })];
                    case 2:
                        warrantyValues = (_a.sent()).data;
                        this.warrantyInfo = warrantyValues;
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.warningMessage = this.$t("deviceSpecificationsView.limitedInformationAvailable");
                        return [3 /*break*/, 4];
                    case 4:
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceWarrantyInfoView.prototype, "device", void 0);
    DeviceWarrantyInfoView = tslib_1.__decorate([
        Component
    ], DeviceWarrantyInfoView);
    return DeviceWarrantyInfoView;
}(Vue));
export default DeviceWarrantyInfoView;
